<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/logo.svg')"
    title="Favicon"
    @initializeData="initializeData"
  >
    <template #main>
      <ImageUploadButton
        label="Upload a transparent PNG max 32x32px. Favicons are usually the same as the icon logos. The asset must be a square to work."
        :image="faviconUrl"
        :acceptedTypes="['.png', '.jpg', '.jpeg', '.ico', '.webp']"
        :s3BucketPath="s3BucketPath"
        :security="filestackSecurity"
        @changeImageUrl="handleImageUrlChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import logger from '@goldcast/logger';
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ImageUploadButton from '../components/ImageUploadButton.vue';

import { getFilestackSecurity } from '@/components/core/Filestack/filestackSecurity';
import { GET_RESOURCES_PATH } from '@/constants';

export default {
  name: 'Favicon',
  components: {
    ModuleWrapper,
    ImageUploadButton
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      s3BucketPath: `${GET_RESOURCES_PATH(this.$route.params.eventId)}`,
      faviconUrl: null,
      filestackSecurity: null
    };
  },
  async mounted() {
    this.initializeData();
    if (this.$store.getters['org/isSignedFilestackUploadsEnabled']) {
      try {
        const { security } = await getFilestackSecurity({
          intent: 'event_asset',
          assetKind: 'image',
          event: this.$route.params.eventId
        });
        this.filestackSecurity = security;
      } catch (e) {
        logger.warn('Failed to fetch Filestack security, upload will fail', e);
      }
    }
  },
  computed: {
    ...mapGetters('branding', {
      changesMade: 'getChangesMade',
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInEvent: 'setChangesMadeInEvent'
    }),
    initializeData() {
      const moduleKeys = ['favicon'];
      const moduleData = this.getInitialModuleData(moduleKeys);
      this.faviconUrl = moduleData.favicon;
    },
    handleImageUrlChange(url) {
      this.faviconUrl = url;
      this.setChangesMadeInEvent({
        favicon: url || null
      });
    }
  }
};
</script>
